import { IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import {
  Drawer,
  Box,
  Typography,
  Button,
  DrawerProps,
  SxProps,
} from '@mui/material';
import { useState } from 'react';
import { BLOOM_CONFIG } from '../PerformanceDrawer/performanceDrawerData';

export const SWItem = ({
  icon,
  title,
  subtitle,
  variant,
  bloomLevel,
  bloomLevels,
}: {
  icon: string;
  title: string;
  subtitle: string;
  variant: 'strengths' | 'weaknesses';
  bloomLevel?: keyof typeof BLOOM_CONFIG;
  bloomLevels?: (keyof typeof BLOOM_CONFIG)[];
}) => {
  const bloom = bloomLevel ? BLOOM_CONFIG[bloomLevel] : null;
  const blooms =
    (bloomLevels?.map((bloom) => BLOOM_CONFIG[bloom]) || []).filter(
      (val) => !!val
    ) || [];
  const styles =
    variant === 'strengths'
      ? {
          bg: 'linear-gradient(135deg, #f0fdf4, #dcfce7)',
          border: '#bbf7d0',
        }
      : {
          bg: 'linear-gradient(135deg, #fffbeb, #fef3c7)',
          border: '#fde68a',
        };
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: pxToRem(10),
        padding: `${pxToRem(10)} ${pxToRem(12)}`,
        background: styles.bg,
        border: `1px solid ${styles.border}`,
        borderRadius: pxToRem(6),
      }}
    >
      <Typography sx={{ fontSize: pxToRem(18) }}>{icon}</Typography>

      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontSize: pxToRem(13), fontWeight: 700 }}>
          {title}
        </Typography>

        <Typography sx={{ fontSize: pxToRem(11), color: '#64748b' }}>
          {subtitle}
        </Typography>
        {/* BLOOM TAG  */}
        {bloomLevel && (
          <Box sx={{ display: 'flex', gap: pxToRem(6), mt: pxToRem(6) }}>
            <Box
              sx={{
                fontSize: pxToRem(10),
                fontWeight: 700,
                px: pxToRem(8),
                py: pxToRem(2),
                borderRadius: pxToRem(6),
                background: bloom?.bg,
                color: bloom?.color,
                textTransform: 'uppercase',
                letterSpacing: '0.3px',
              }}
            >
              {bloom?.label}
            </Box>
          </Box>
        )}
        {blooms.length > 0 && (
          <Box sx={{ display: 'flex', gap: pxToRem(6), mt: pxToRem(6) }}>
            {blooms.map((bloom) => {
              return (
                <Box
                  key={bloom?.label}
                  sx={{
                    fontSize: pxToRem(10),
                    fontWeight: 700,
                    px: pxToRem(8),
                    py: pxToRem(2),
                    borderRadius: pxToRem(6),
                    background: bloom?.bg,
                    color: bloom?.color,
                    textTransform: 'uppercase',
                    letterSpacing: '0.3px',
                  }}
                >
                  {bloom?.label}
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </Box>
  );
};
